/* AFTER FOUR V49 | Accessible two-tap finder and catalogue filtering. */
(() => {
  'use strict';
  const bind = (root = document) => {
    root.querySelectorAll('[data-af49-matcher]').forEach((matcher) => {
      if (matcher.dataset.af49Ready === 'true') return;
      matcher.dataset.af49Ready = 'true';
      let mood = 'spicy', texture = 'makhana';
      const setGroup = (selector, selectedValue) => {
        matcher.querySelectorAll(selector).forEach((button) => {
          const value = button.dataset.af49Mood ?? button.dataset.af49Texture;
          const active = value === selectedValue;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };
      const update = () => {
        const results = matcher.querySelectorAll('[data-af49-result]');
        let matched = false;
        results.forEach((item) => {
          const active = item.dataset.mood === mood && item.dataset.texture === texture;
          item.hidden = !active;
          if (active) matched = true;
        });
        if (!matched && results.length) {
          const closest = Array.from(results).find((item) => item.dataset.texture === texture);
          if (closest) closest.hidden = false;
          else results[0].hidden = false;
        }
        setGroup('[data-af49-mood]', mood);
        setGroup('[data-af49-texture]', texture);
      };
      matcher.addEventListener('click', (event) => {
        const el = event.target instanceof Element ? event.target.closest('button[data-af49-mood],button[data-af49-texture]') : null;
        if (!el || !matcher.contains(el)) return;
        if (el.dataset.af49Mood) mood = el.dataset.af49Mood;
        if (el.dataset.af49Texture) texture = el.dataset.af49Texture;
        update();
      });
      update();
    });
    root.querySelectorAll('[data-af49-shop-catalog]').forEach((catalog) => {
      if (catalog.dataset.af49Ready === 'true') return;
      catalog.dataset.af49Ready = 'true';
      catalog.addEventListener('click', (event) => {
        const button = event.target instanceof Element
          ? event.target.closest('button[data-af49-catalog-filter]') : null;
        if (!button || !catalog.contains(button)) return;
        const selected = button.dataset.af49CatalogFilter;
        catalog.querySelectorAll('button[data-af49-catalog-filter]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('on', active);
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        catalog.querySelectorAll('[data-af49-catalog-kind]').forEach((card) => {
          card.hidden = selected !== 'all' && card.dataset.af49CatalogKind !== selected;
        });
      });
    });
    root.querySelectorAll('[data-af49-shop]').forEach((shop) => {
      if (shop.dataset.af49Ready === 'true') return;
      shop.dataset.af49Ready = 'true';
      shop.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('button[data-af49-filter]') : null;
        if (!button || !shop.contains(button)) return;
        const filter = button.dataset.af49Filter;
        shop.querySelectorAll('button[data-af49-filter]').forEach((b) => {
          const chosen = b === button;
          b.classList.toggle('is-active', chosen);
          b.setAttribute('aria-pressed', String(chosen));
        });
        shop.querySelectorAll('[data-af49-kind]').forEach((product) => {
          product.hidden = filter !== 'all' && product.dataset.af49Kind !== filter;
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind(), { once: true });
  else bind();
  document.addEventListener('shopify:section:load', (event) => bind(event.target || document));
})();